import InputType from "common/form/InputType";
import { Form, Input } from "decorator-form";

@Form({title: "Text Panel Config"})
export default class DateReminderConfig {

	@Input({type: InputType.TEXT, title: "Event name"})
	public eventName: string;

	@Input({type: InputType.CHECKBOX, title: "Prompt automatically if no date selected"})
	public prompt: boolean;

}



// WEBPACK FOOTER //
// ./src/panels/dateReminder/DateReminderConfig.ts